import SkillsList from "../Components/Skills/SkillsList";

const SkillsListPage = () => {
  return (
    <div>
      <SkillsList />
    </div>
  );
};

export default SkillsListPage;
